import { Card, CardActions, CardContent, Grid, Typography } from '@mui/material';
import { useFormik } from 'formik';
import { PmiButton } from 'shell/components/shared/button';
import { ReactElement, useCallback } from 'react';
import * as yup from 'yup';
import PmiTextField from 'shell/components/shared/text-field';

export interface DocumentRegistryForm {
  number?: string;
  description?: string;
}

const validationSchema = yup.object({
  number: yup.string().required('Il campo è obbligatorio'),
  description: yup.string().required('Il campo è obbligatorio'),
});

interface FormDocumentRegistryProps {
  onOk: (form: DocumentRegistryForm) => void;
  onCancel: (form?: DocumentRegistryForm) => void;
  title: string;
  children?: ReactElement;
  disabled?: boolean;
  isEdit?: boolean;
  initialValues?: DocumentRegistryForm;
}

const FormDocumentRegistry = ({
  onOk,
  onCancel,
  title,
  isEdit,
  disabled = false,
  initialValues,
}: FormDocumentRegistryProps): React.ReactElement => {
  const onSubmit = useCallback(
    (formValues) => {
      onOk(formValues);
    },
    [onOk]
  );

  const formDocumentRegistry = useFormik<DocumentRegistryForm>({
    initialValues: initialValues || {
      number: '',
      description: '',
    },
    validationSchema: validationSchema,
    onSubmit,
    enableReinitialize: true,
    validateOnMount: true,
  });

  return (
    <Card raised className="pmi-my-3">
      <form onSubmit={formDocumentRegistry.handleSubmit}>
        <CardContent style={{ padding: '24px' }}>
          <Typography gutterBottom variant="h5" component="h2">
            {title}
          </Typography>
          <div style={{ padding: '24px 0 0 0' }}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={4}>
                <PmiTextField
                  aria-label="Numero"
                  label="Numero *"
                  id="number"
                  name="number"
                  type="text"
                  variant="outlined"
                  value={formDocumentRegistry.values.number || ''}
                  disabled={disabled || isEdit}
                  inputProps={{
                    maxLength: '2',
                  }}
                  fullWidth
                  onChange={formDocumentRegistry.handleChange}
                  error={
                    formDocumentRegistry.touched.number &&
                    Boolean(formDocumentRegistry.errors.number)
                  }
                  helperText={formDocumentRegistry.errors.number}
                />
              </Grid>
              <Grid item xs={12} md={8}>
                <PmiTextField
                  aria-label="Descrizione"
                  label="Descrizione *"
                  id="description"
                  name="description"
                  type="text"
                  variant="outlined"
                  value={formDocumentRegistry.values.description || ''}
                  disabled={disabled}
                  fullWidth
                  inputProps={{
                    maxLength: '30',
                  }}
                  onChange={formDocumentRegistry.handleChange}
                  error={
                    formDocumentRegistry.touched.description &&
                    Boolean(formDocumentRegistry.errors.description)
                  }
                  helperText={formDocumentRegistry.errors.description}
                />
              </Grid>
            </Grid>
          </div>
        </CardContent>
        <CardActions style={{ padding: '24px 24px 16px 24px' }}>
          <PmiButton variant="contained" color="primary" type="submit" disabled={disabled}>
            Conferma
          </PmiButton>
          <PmiButton
            variant="outlined"
            color="cdmBrand"
            onClick={() => {
              onCancel(formDocumentRegistry.values);
            }}
          >
            Annulla
          </PmiButton>
        </CardActions>
      </form>
    </Card>
  );
};

FormDocumentRegistry.displayName = 'Form Document Registry component';

export default FormDocumentRegistry;
